<app-progress></app-progress>
<div class="p-8 table-list mat-typography">
    <mat-card class="flex items-center justify-center bg-gray-50 p-4">
    <mat-card-header>
      <mat-card-title>
        CSV Item Upload
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form class="center" (ngSubmit)="submit()">
          <input
              #fileInput
              type="file"
              (change)="checkFile($event)"
              style="display: none;"
          />
          <button
              type="button"
              mat-raised-button
              style="margin-bottom: 10px"
              (click)="fileInput.click()"
              class="center"
          >
          <mat-icon>library_add</mat-icon>
          <span>Select CSV File</span>
          </button>
          <div class="button-row">
          <button [disabled]="invalid" color="primary" mat-raised-button type="submit">Parse</button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>

<div class="pl-8 pr-8 table-list mat-typography">
    <mat-card>
    <mat-card-header>
      <mat-card-title>{{dataSource && dataSource.data ? dataSource.data.length : ''}} Items</mat-card-title>
      @if (parsed) {
        <mat-card-subtitle style="text-align: center;">Click "Upload" to complete the CSV file upload.</mat-card-subtitle>
      }
      @if (errors.length > 0) {
        <mat-card-subtitle style="color: red; text-align: center;">Errors found. File was not uploaded.</mat-card-subtitle>
      }
      @if (headerErrors.length > 0) {
        <mat-card-subtitle style="color: red; text-align: center;">Header errors found. File was not parsed.</mat-card-subtitle>
      }
      @if (errors.length > 0) {
        <mat-card-subtitle>
          <mat-chip-listbox aria-label="Upload Errors">
            @for (error of errors; track error) {
              <mat-chip-option [selected]="true" color="warn">{{error}}</mat-chip-option>
            }
          </mat-chip-listbox>
        </mat-card-subtitle>
      }
      @if (headerErrors.length > 0) {
        <mat-card-subtitle>
          <mat-chip-listbox aria-label="Upload Errors">
            @for (error of headerErrors; track error) {
              <mat-chip-option selected="true" color="warn">{{error}}</mat-chip-option>
            }
          </mat-chip-listbox>
        </mat-card-subtitle>
      }
    </mat-card-header>
    <mat-card-content class="w-full">
      <table [dataSource]="dataSource" mat-table matSort [multiTemplateDataRows]="true">

        <!-- Tag Column -->
        <ng-container matColumnDef="tag">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Tag</th>
          <td *matCellDef="let element" mat-cell>{{element.tag}}</td>
        </ng-container>

        <!-- Facility Name Column -->
        <ng-container matColumnDef="facilityName">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Facility</th>
          <td *matCellDef="let element" mat-cell>{{element.facility}}</td>
        </ng-container>

        <!-- Location Column -->
        <ng-container matColumnDef="locationName">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Location</th>
          <td *matCellDef="let element" mat-cell>{{element.location}}</td>
        </ng-container>

        <!-- Customer Part Number Column -->
        <ng-container matColumnDef="customerPartNumber">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Customer Part Number</th>
          <td *matCellDef="let element" mat-cell>{{element.customerPartNumber}}</td>
        </ng-container>

        <!-- Eclipse ID Column -->
        <ng-container matColumnDef="eclipseId">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Eclipse ID</th>
          <td *matCellDef="let element" mat-cell>{{element.eclipseId}}</td>
        </ng-container>

        <!-- Item Type Column -->
        <ng-container matColumnDef="itemType">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Item Type</th>
          <td *matCellDef="let element" mat-cell>{{element.itemType}}</td>
        </ng-container>

        <!-- Item Description Column -->
        <ng-container matColumnDef="itemDescription">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Item Description</th>
          <td *matCellDef="let element" mat-cell>{{element.itemDescription}}</td>
        </ng-container>

        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Quantity</th>
          <td *matCellDef="let element"
          mat-cell>{{element.quantity}}</td>
        </ng-container>

        <ng-container matColumnDef="tags">
          <td *matCellDef="let item" [attr.colspan]="displayedColumns.length" mat-cell>
            <div class="item-detail">
              @for (tag of item.tags; track tag) {
                <div class="item-tag">
                  <div class="tag-type">{{tag.type}}</div>
                  <div class="tag-value">{{tag.value}}</div>
                </div>
              }
            </div>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr (click)="expandedItem === item? expandedItem = null : expandedItem = item"
          *matRowDef="let item; columns: displayedColumns;"
          [class.expanded]="expandedItem === item"
          class="item-row"
          mat-row>
        </tr>
        <tr *matRowDef="let row; columns: ['tags'];"
          [@detailExpand]="row == expandedItem ? 'expanded' : 'collapsed'"
          mat-row
        style="overflow: hidden"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[15, 50, 100]" [showFirstLastButtons]="true"></mat-paginator>
    </mat-card-content>
    <mat-card-actions>
      <div class="w-full flex items-center justify-center gap-2">
        <button (click)="upload()" [disabled]="dataSource.data.length === 0" mat-raised-button>
          Upload
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
